webpackJsonp([31029245590386],{

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _get = __webpack_require__(8);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _gatsbyImage = __webpack_require__(6);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _moment = __webpack_require__(13);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _postDetailModule = __webpack_require__(71);
	
	var _postDetailModule2 = _interopRequireDefault(_postDetailModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProgramTemplate = function (_React$Component) {
	  _inherits(ProgramTemplate, _React$Component);
	
	  function ProgramTemplate() {
	    _classCallCheck(this, ProgramTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgramTemplate.prototype.render = function render() {
	    var post = (0, _get2.default)(this.props, 'data.contentfulProgram');
	    var siteData = (0, _get2.default)(this.props, 'data.site.siteMetadata');
	
	    return _react2.default.createElement(
	      'div',
	      { style: { background: '#fff' }, className: 'page-content page-program-detail' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        { title: post.title + ' | ' + siteData.title },
	        _react2.default.createElement('link', { rel: 'canonical', href: siteData.siteUrl + '/article/' + post.slug }),
	        _react2.default.createElement('meta', { name: 'description', content: '' + post.excerpt }),
	        _react2.default.createElement('meta', { name: 'title', content: post.title + ' | ' + siteData.title }),
	        _react2.default.createElement('meta', { property: 'og:title', content: post.title + ' | ' + siteData.title }),
	        _react2.default.createElement('meta', { property: 'og:site_name', content: 'YOUCAT Indonesia' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: siteData.siteUrl + '/program/' + post.slug }),
	        _react2.default.createElement('meta', { property: 'og:description', content: '' + post.excerpt }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://static.youcat.id/ogimg/ogimg-youcat.png' }),
	        _react2.default.createElement('meta', { property: 'og:locale', content: 'id_ID' }),
	        _react2.default.createElement('meta', { property: 'og:type', content: 'article' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-x grid-padding-x grid-padding-y' },
	        _react2.default.createElement(
	          'div',
	          { className: 'program-image post-image cell medium-shrink ' + _postDetailModule2.default.postThumbWrapper },
	          _react2.default.createElement(_gatsbyImage2.default, { className: _postDetailModule2.default.postThumb, alt: post.title, sizes: post.thumbnail.sizes })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cell medium-auto' },
	          _react2.default.createElement(
	            'h1',
	            { className: _postDetailModule2.default.postTitle },
	            post.title
	          ),
	          _react2.default.createElement(
	            'small',
	            null,
	            'Kategori: ',
	            post.programCategory
	          ),
	          _react2.default.createElement('div', { className: _postDetailModule2.default.bodyContent,
	            dangerouslySetInnerHTML: {
	              __html: post.body.childMarkdownRemark.html
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return ProgramTemplate;
	}(_react2.default.Component);
	
	exports.default = ProgramTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-program-post-js-7115234b0965410be938.js